// ============================================================================
// FRENCH TRANSLATIONS - CHAPTER 3: JÉSUS-CHRIST
// ============================================================================
// Niveaux 27-39 (13 niveaux, 39 questions)

export const chapter3Translations = {
  name: "Jésus-Christ",
  description: "La Parole faite chair... Connaître Christ, c'est la vie éternelle",
  
  spiritualWisdom: {
    principle: "Connaître Jésus-Christ, c'est la vie éternelle",
    scripture: "Or, la vie éternelle, c'est qu'ils te connaissent, toi le seul vrai Dieu, et celui que tu as envoyé, Jésus-Christ (Jean 17:3)",
    application: "Chaque aspect de la vie de Jésus révèle Dieu et nourrit notre âme pour l'éternité"
  },
  
  levels: {
    27: {
      name: "L'Annonciation",
      challenge: "L'ange Gabriel fut envoyé par Dieu dans une ville de Galilée...",
      easy: {
        question: "Quel ange annonça à Marie qu'elle porterait Jésus ?",
        options: ["Michel", "Gabriel", "Raphaël", "Uriel"],
        hint: "L'ange messager de Dieu",
        funFact: "👼 Gabriel signifie 'Force de Dieu' - l'ange des grandes annonces!"
      },
      medium: {
        question: "Quelle fut la première réaction de Marie à cette annonce ?",
        options: [
          "La joie immédiate",
          "L'incrédulité totale",
          "Le trouble et la question 'Comment cela se fera-t-il ?'",
          "La peur"
        ],
        hint: "Une question pratique et légitime",
        funFact: "🤔 Marie pose une question logique mais garde un cœur ouvert à Dieu!"
      },
      hard: {
        question: "Que nous enseigne la soumission de Marie à la volonté divine ?",
        options: [
          "La passivité face aux épreuves",
          "La foi qui fait confiance même sans tout comprendre",
          "L'obéissance aveugle",
          "La résignation"
        ],
        hint: "Il s'agit de faire confiance à Dieu même dans l'inconnu",
        funFact: "🙏 'Qu'il me soit fait selon ta parole' - modèle de foi confiante!"
      }
    },
    
    28: {
      name: "La Nativité",
      challenge: "Elle enfanta son fils premier-né, l'emmaillota et le coucha dans une crèche...",
      easy: {
        question: "Dans quelle ville Jésus est-il né ?",
        options: ["Nazareth", "Jérusalem", "Bethléem", "Capharnaüm"],
        hint: "La ville de David",
        funFact: "🏘️ Bethléem signifie 'Maison du pain' - Jésus, pain de vie!"
      },
      medium: {
        question: "Qui furent les premiers à recevoir l'annonce de la naissance ?",
        options: [
          "Les rois mages",
          "Les bergers dans les champs",
          "Les prêtres du Temple",
          "La famille de Marie"
        ],
        hint: "Des gens simples qui gardaient leurs troupeaux",
        funFact: "🐑 Dieu annonce d'abord aux humbles bergers - l'Évangile pour tous!"
      },
      hard: {
        question: "Que symbolise Jésus né dans une crèche ?",
        options: [
          "La pauvreté de ses parents",
          "L'humilité de Dieu qui s'abaisse jusqu'à nous",
          "Le manque de place",
          "La simplicité rurale"
        ],
        hint: "Il s'agit de l'incarnation divine dans l'humilité",
        funFact: "👶 Le Créateur de l'univers naît dans une étable - amour infini!"
      }
    },

    29: {
      name: "Les Mages d'Orient",
      challenge: "Des mages d'Orient arrivèrent à Jérusalem et demandèrent...",
      easy: {
        question: "Qu'est-ce qui guida les mages vers Jésus ?",
        options: ["Un ange", "Une étoile", "Une vision", "Une carte"],
        hint: "Un astre dans le ciel",
        funFact: "⭐ L'étoile représente que Jésus est la lumière des nations!"
      },
      medium: {
        question: "Quels cadeaux offrirent les mages ?",
        options: [
          "De la nourriture",
          "Or, encens et myrrhe",
          "Des vêtements précieux",
          "Des jouets"
        ],
        hint: "Trois présents symboliques et précieux",
        funFact: "🎁 Or (royauté), encens (divinité), myrrhe (sacrifice) - toute la mission de Jésus!"
      },
      hard: {
        question: "Que représentent ces mages païens dans le plan de Dieu ?",
        options: [
          "La supériorité des autres religions",
          "L'universalité du salut offert à tous les peuples",
          "La richesse matérielle",
          "La science ancienne"
        ],
        hint: "Il s'agit de l'ouverture du salut à toutes les nations",
        funFact: "🌍 Les mages préfigurent l'Évangile qui atteindra le monde entier!"
      }
    },

    30: {
      name: "Le Baptême de Jésus",
      challenge: "Dès que Jésus eut été baptisé, il remonta de l'eau...",
      easy: {
        question: "Qui baptisa Jésus ?",
        options: ["Pierre", "Jean-Baptiste", "André", "Jacques"],
        hint: "Le précurseur de Jésus",
        funFact: "🌊 Jean-Baptiste se considérait indigne de délier les sandales de Jésus!"
      },
      medium: {
        question: "Qu'est-ce qui descendit sur Jésus lors de son baptême ?",
        options: [
          "Une lumière",
          "Une colombe (le Saint-Esprit)",
          "Un ange",
          "Une voix seulement"
        ],
        hint: "L'oiseau symbole de paix",
        funFact: "🕊️ La colombe révèle l'onction divine pour commencer le ministère!"
      },
      hard: {
        question: "Pourquoi Jésus, sans péché, s'est-il fait baptiser ?",
        options: [
          "Pour montrer l'exemple",
          "Pour accomplir toute justice et s'identifier à nous",
          "Par obligation religieuse",
          "Pour recevoir le pardon"
        ],
        hint: "Il s'agit de solidarité avec l'humanité pécheresse",
        funFact: "❤️ Jésus s'identifie totalement à nous pour mieux nous sauver!"
      }
    },

    31: {
      name: "La Tentation au Désert",
      challenge: "Jésus fut emmené par l'Esprit dans le désert pour être tenté par le diable...",
      easy: {
        question: "Combien de temps Jésus jeûna-t-il au désert ?",
        options: ["30 jours", "40 jours", "50 jours", "60 jours"],
        hint: "Le nombre biblique de l'épreuve",
        funFact: "🏜️ Comme Moïse et Élie, 40 jours de préparation spirituelle intense!"
      },
      medium: {
        question: "Comment Jésus repoussa-t-il chaque tentation ?",
        options: [
          "Par sa propre force",
          "En citant les Écritures",
          "En ignorant Satan",
          "En priant seulement"
        ],
        hint: "L'arme spirituelle par excellence",
        funFact: "📖 'Il est écrit...' - la Parole de Dieu, épée de l'Esprit!"
      },
      hard: {
        question: "Que nous apprend la tentation de Jésus sur nos combats ?",
        options: [
          "Les tentations sont péché",
          "La tentation peut être vaincue par la Parole et la foi",
          "Il faut fuir tout désert",
          "Seul Jésus peut résister"
        ],
        hint: "Il s'agit de notre stratégie face aux tentations",
        funFact: "⚔️ Jésus nous montre comment vaincre : Parole de Dieu + foi active!"
      }
    },

    32: {
      name: "Les Premiers Disciples",
      challenge: "Jésus leur dit : Suivez-moi, et je vous ferai pêcheurs d'hommes...",
      easy: {
        question: "Quel était le métier de Pierre et André ?",
        options: ["Bergers", "Pêcheurs", "Charpentiers", "Collecteurs d'impôts"],
        hint: "Un métier du lac de Galilée",
        funFact: "🎣 Jésus transforme les pêcheurs de poissons en pêcheurs d'âmes!"
      },
      medium: {
        question: "Comment réagirent les premiers disciples à l'appel ?",
        options: [
          "Ils hésitèrent longtemps",
          "Ils demandèrent des preuves",
          "Ils laissèrent tout et le suivirent aussitôt",
          "Ils négocièrent"
        ],
        hint: "Une réponse immédiate et totale",
        funFact: "🚶 L'autorité de Jésus était si évidente qu'ils obéirent instantanément!"
      },
      hard: {
        question: "Que signifie 'suivre Jésus' dans notre époque ?",
        options: [
          "Abandonner son travail",
          "Vivre selon ses enseignements et sa volonté",
          "Rejoindre une communauté isolée",
          "Faire du prosélytisme seulement"
        ],
        hint: "Il s'agit d'une transformation de vie et de priorités",
        funFact: "✨ Suivre Jésus transforme nos cœurs, nos choix, notre destinée!"
      }
    },

    33: {
      name: "Le Sermon sur la Montagne",
      challenge: "Heureux les pauvres en esprit, car le royaume des cieux est à eux...",
      easy: {
        question: "Par quels mots commencent les Béatitudes ?",
        options: ["Bénis soient", "Heureux", "Aimés", "Choisis"],
        hint: "Un mot qui exprime la joie spirituelle",
        funFact: "😊 'Heureux' révèle que Dieu veut notre bonheur véritable!"
      },
      medium: {
        question: "Que dit Jésus de ceux qui sont persécutés pour la justice ?",
        options: [
          "Ils seront vengés",
          "Le royaume des cieux est à eux",
          "Ils doivent se défendre",
          "Ils sont maudits"
        ],
        hint: "La même promesse que la première béatitude",
        funFact: "👑 Souffrir pour la justice assure l'héritage du Royaume!"
      },
      hard: {
        question: "Comment les Béatitudes révolutionnent-elles nos valeurs ?",
        options: [
          "En prônant la pauvreté",
          "En renversant les valeurs du monde : humilité, mercy, justice",
          "En condamnant la richesse",
          "En isolant les croyants"
        ],
        hint: "Il s'agit de valeurs divines opposées aux valeurs mondaines",
        funFact: "🔄 Les Béatitudes transforment notre vision du bonheur et du succès!"
      }
    },

    34: {
      name: "Les Paraboles du Royaume",
      challenge: "Il leur enseignait beaucoup de choses en paraboles...",
      easy: {
        question: "Dans la parabole du semeur, que représente la semence ?",
        options: [
          "L'argent",
          "La Parole de Dieu",
          "Les bonnes œuvres",
          "L'amour"
        ],
        hint: "Ce que Jésus annonce et enseigne",
        funFact: "🌱 La Parole de Dieu germe et grandit dans nos cœurs!"
      },
      medium: {
        question: "Dans la parabole du grain de moutarde, que symbolise cette petite graine ?",
        options: [
          "La faiblesse humaine",
          "Le Royaume qui commence petit mais devient grand",
          "L'importance des détails",
          "La nature"
        ],
        hint: "Quelque chose qui grandit de façon spectaculaire",
        funFact: "🌳 De la plus petite graine naît un grand arbre - puissance du Royaume!"
      },
      hard: {
        question: "Pourquoi Jésus enseignait-il en paraboles ?",
        options: [
          "Pour compliquer son message",
          "Pour révéler les vérités spirituelles par des images familières",
          "Par manque de temps",
          "Pour tester l'intelligence"
        ],
        hint: "Il s'agit de rendre accessible les mystères du Royaume",
        funFact: "💡 Les paraboles révèlent aux cœurs ouverts et voilent aux cœurs fermés!"
      }
    },

    35: {
      name: "Les Miracles de Jésus",
      challenge: "Il calma le vent et dit à la mer : Silence ! tais-toi !...",
      easy: {
        question: "Avec combien de pains Jésus nourrit-il 5000 hommes ?",
        options: ["3 pains", "5 pains", "7 pains", "12 pains"],
        hint: "Le même nombre que les poissons",
        funFact: "🍞 5 pains et 2 poissons deviennent un festin - générosité divine!"
      },
      medium: {
        question: "Que dirent les disciples quand Jésus calma la tempête ?",
        options: [
          "Il est magicien",
          "Quel est donc celui-ci à qui obéissent le vent et la mer ?",
          "C'est normal",
          "Il faut partir d'ici"
        ],
        hint: "Une question sur l'identité de Jésus",
        funFact: "⛈️ Même les éléments reconnaissent leur Créateur et Maître!"
      },
      hard: {
        question: "Quel est le but principal des miracles de Jésus ?",
        options: [
          "Impressionner les foules",
          "Révéler sa divinité et manifester l'amour de Dieu",
          "Gagner de l'influence",
          "Aider matériellement seulement"
        ],
        hint: "Il s'agit de révélation divine et de compassion",
        funFact: "❤️ Chaque miracle révèle le cœur de Dieu : amour, compassion, puissance!"
      }
    },

    36: {
      name: "La Transfiguration",
      challenge: "Il fut transfiguré devant eux; son visage resplendit comme le soleil...",
      easy: {
        question: "Quels disciples virent Jésus transfiguré ?",
        options: [
          "Tous les douze",
          "Pierre, Jacques et Jean",
          "Pierre et Jean seulement",
          "Les femmes qui le suivaient"
        ],
        hint: "Le cercle intime des trois",
        funFact: "⛰️ Pierre, Jacques et Jean : témoins privilégiés de la gloire divine!"
      },
      medium: {
        question: "Quels personnages de l'Ancien Testament apparurent ?",
        options: [
          "Abraham et Isaac",
          "David et Salomon",
          "Moïse et Élie",
          "Adam et Noé"
        ],
        hint: "Le représentant de la Loi et celui des Prophètes",
        funFact: "📜 Moïse (Loi) et Élie (Prophètes) rendent témoignage à Jésus!"
      },
      hard: {
        question: "Que révèle cette transfiguration sur la nature de Jésus ?",
        options: [
          "Il est un grand prophète",
          "Sa divinité cachée se manifeste temporairement",
          "Il maîtrise la lumière",
          "Il peut changer d'apparence"
        ],
        hint: "Il s'agit de la révélation de sa nature divine",
        funFact: "✨ La gloire divine de Jésus transparaît - aperçu de sa résurrection!"
      }
    },

    37: {
      name: "L'Entrée Triomphale",
      challenge: "Hosanna au Fils de David ! Béni soit celui qui vient au nom du Seigneur !...",
      easy: {
        question: "Sur quel animal Jésus entra-t-il à Jérusalem ?",
        options: ["Un cheval", "Un âne", "Un chameau", "À pied"],
        hint: "Un animal symbole d'humilité et de paix",
        funFact: "🐴 L'âne symbolise le Roi humble qui vient en paix, non en guerre!"
      },
      medium: {
        question: "Que criait la foule en acclamant Jésus ?",
        options: [
          "Vive le Roi !",
          "Hosanna ! Béni soit celui qui vient au nom du Seigneur !",
          "Gloire à Dieu !",
          "Liberté !"
        ],
        hint: "Un cri de joie et de bénédiction",
        funFact: "🌿 'Hosanna' signifie 'Sauve maintenant' - appel au salut divin!"
      },
      hard: {
        question: "Pourquoi cette entrée est-elle 'triomphale' mais tragique ?",
        options: [
          "Il y avait peu de monde",
          "La foule qui l'acclame le rejettera dans 5 jours",
          "Les autorités étaient absentes",
          "Il pleuvait"
        ],
        hint: "Il s'agit de l'inconstance du cœur humain",
        funFact: "💔 La même foule criera 'Crucifie-le !' quelques jours plus tard!"
      }
    },

    38: {
      name: "La Dernière Cène",
      challenge: "Prenez et mangez, ceci est mon corps qui est donné pour vous...",
      easy: {
        question: "Que fit Jésus aux pieds de ses disciples ?",
        options: [
          "Il les bénit",
          "Il les lava",
          "Il les parfuma",
          "Il les embrassa"
        ],
        hint: "Un geste d'humilité et de service",
        funFact: "🦶 Le Maître se fait serviteur - révolution d'amour et d'humilité!"
      },
      medium: {
        question: "Qu'institua Jésus lors de ce repas ?",
        options: [
          "Le baptême",
          "La communion (Sainte Cène)",
          "La prière du Notre Père",
          "Le jeûne"
        ],
        hint: "Un sacrement avec le pain et le vin",
        funFact: "🍞🍷 Pain et vin deviennent symboles éternels de sacrifice et d'amour!"
      },
      hard: {
        question: "Que signifie 'Faites ceci en mémoire de moi' ?",
        options: [
          "Répétez ce repas",
          "Célébrez ma mort et résurrection jusqu'à mon retour",
          "Souvenez-vous de mes paroles",
          "Aimez-vous les uns les autres"
        ],
        hint: "Il s'agit d'une commémoration vivante et prophétique",
        funFact: "⏳ Chaque communion annonce la mort du Seigneur jusqu'à son retour!"
      }
    },

    39: {
      name: "Gethsémané",
      challenge: "Mon Père, s'il est possible, que cette coupe s'éloigne de moi...",
      easy: {
        question: "Où Jésus pria-t-il avant son arrestation ?",
        options: [
          "Dans le Temple",
          "Au jardin de Gethsémané",
          "Sur le mont des Oliviers",
          "Chez ses amis"
        ],
        hint: "Un jardin aux oliviers",
        funFact: "🫒 Gethsémané signifie 'pressoir à huile' - lieu de pression intense!"
      },
      medium: {
        question: "Que firent les disciples pendant que Jésus priait ?",
        options: [
          "Ils prièrent avec lui",
          "Ils s'endormirent",
          "Ils montèrent la garde",
          "Ils partirent"
        ],
        hint: "Ils ne purent veiller une heure",
        funFact: "😴 L'esprit est prompt mais la chair est faible - faiblesse humaine!"
      },
      hard: {
        question: "Que révèle l'agonie de Jésus sur sa nature ?",
        options: [
          "Il n'était qu'homme",
          "Il était pleinement homme ET pleinement Dieu",
          "Il doutait de sa mission",
          "Il était faible"
        ],
        hint: "Il s'agit du mystère de l'incarnation",
        funFact: "✝️ Jésus assume pleinement l'angoisse humaine tout en restant fidèle à Dieu!"
      }
    }
  }
};

export default chapter3Translations;
